import _ from '../underscore_extend';


var domains = {
    '126.com': ['sg'],
    '163.com': ['us','sg'],
    'abv.bg': ['us','eu'],
    'aim.com': ['us'],
    'aol.com': ['us','eu'],
    'att.net': ['us'],
    'azet.sk': ['eu'],
    'bigmir.net': ['ru'],
    'bigpond.com': ['sg'],
    'bk.ru': ['ru'],
    'centrum.cz': ['eu'],
    'centrum.sk': ['eu'],
    'charter.net': ['us'],
    'citromail.hu': ['us','eu'],
    'comcast.net': ['us'],
    'cox.net': ['us'],
    'daum.com': ['kr'],
    'daum.net': ['kr'],
    'demo.loc': ['us','sg','ru'],
    'dreamwiz.com': ['kr'],
    'e-mail.ua': ['ru'],
    'e1.ru': ['ru'],
    'email.cz': ['eu'],
    'email.ru': ['ru'],
    'email.ua': ['ru'],
    'ezweb.ne.jp': ['sg'],
    'freemail.hu': ['us','eu'],
    'freenet.de': ['eu'],
    'front.ru': ['ru'],
    'gmail.com': ['us','sg','ru','kr','eu'],
    'gmail.ru': ['ru'],
    'gmx.at': ['eu'],
    'gmx.de': ['us','eu'],
    'gmx.net': ['eu'],
    'googlemail.com': ['us','eu'],
    'hanmail.net': ['kr'],
    'hotmail.ca': ['us'],
    'hotmail.co.jp': ['sg'],
    'hotmail.co.nz': ['sg'],
    'hotmail.co.th': ['sg'],
    'hotmail.co.uk': ['us','sg','eu'],
    'hotmail.com': ['us','sg','ru','kr','eu'],
    'hotmail.com.tw': ['sg'],
    'hotmail.de': ['us','eu'],
    'hotmail.es': ['us','eu'],
    'hotmail.fr': ['us','eu'],
    'hotmail.it': ['eu'],
    'hotmail.my': ['sg'],
    'i.ua': ['ru'],
    'inbox.lv': ['ru','eu'],
    'inbox.ru': ['ru'],
    'interia.eu': ['eu'],
    'interia.pl': ['us','eu'],
    'kimo.com': ['sg'],
    'km.ru': ['ru'],
    'laposte.net': ['eu'],
    'lenta.ru': ['ru'],
    'libero.it': ['eu'],
    'list.ru': ['ru'],
    'live.ca': ['us'],
    'live.co.uk': ['eu'],
    'live.com': ['us','sg','eu'],
    'live.com.au': ['sg'],
    'live.de': ['eu'],
    'live.fr': ['us','eu'],
    'live.jp': ['sg'],
    'live.nl': ['eu'],
    'live.ru': ['ru'],
    'lycos.co.kr': ['kr'],
    'mail.by': ['ru'],
    'mail.com': ['us','ru'],
    'mail.goo.ne.jp': ['sg'],
    'mail.ru': ['us','sg','ru','eu'],
    'mail.ua': ['ru'],
    'mailforspam.com': ['ru'],
    'me.com': ['us','sg','ru'],
    'meta.ua': ['ru'],
    'msa.hinet.net': ['sg'],
    'msn.com': ['us','sg','eu'],
    'myopera.com': ['sg'],
    'narod.ru': ['ru'],
    'nate.com': ['kr'],
    'naver.com': ['us','sg','kr'],
    'ngs.ru': ['ru'],
    'nifty.com': ['sg'],
    'nm.ru': ['ru'],
    'o2.pl': ['us','eu'],
    'onet.eu': ['eu'],
    'onet.pl': ['eu'],
    'online.ua': ['ru'],
    'op.pl': ['us','eu'],
    'open.by': ['ru'],
    'optusnet.com.au': ['sg'],
    'orange.fr': ['eu'],
    'outlook.com': ['us','sg'],
    'pisem.net': ['ru'],
    'pochta.ru': ['ru'],
    'poczta.onet.pl': ['eu'],
    'qa.wargaming.net': ['sg','ru'],
    'qip.ru': ['ru'],
    'qq.com': ['us','sg','ru'],
    'rambler.ru': ['ru'],
    'ro.ru': ['ru'],
    'rocketmail.com': ['us','sg'],
    'rogers.com': ['us'],
    'sanook.com': ['sg'],
    'sbcglobal.net': ['us'],
    'seznam.cz': ['us','eu'],
    'shaw.ca': ['us'],
    'sibmail.com': ['ru'],
    'sina.com': ['sg'],
    'spaces.ru': ['ru'],
    't-online.de': ['eu'],
    'thaimail.com': ['sg'],
    'tlen.pl': ['eu'],
    'tut.by': ['ru'],
    'ua.fm': ['ru'],
    'ukr.net': ['ru'],
    'verizon.net': ['us'],
    'vp.pl': ['eu'],
    'web.de': ['us','ru','eu'],
    'windowslive.com': ['sg','eu'],
    'wp.pl': ['us','eu'],
    'xtra.co.nz': ['sg'],
    'ya.ru': ['ru'],
    'yahoo.ca': ['us'],
    'yahoo.co.id': ['sg'],
    'yahoo.co.jp': ['us','sg'],
    'yahoo.co.th': ['sg'],
    'yahoo.co.uk': ['us','sg','eu'],
    'yahoo.com': ['us','sg','ru','kr','eu'],
    'yahoo.com.au': ['sg'],
    'yahoo.com.hk': ['sg'],
    'yahoo.com.my': ['sg'],
    'yahoo.com.ph': ['sg'],
    'yahoo.com.sg': ['sg'],
    'yahoo.com.tw': ['us','sg'],
    'yahoo.com.vn': ['us','sg'],
    'yahoo.de': ['us','eu'],
    'yahoo.fr': ['eu'],
    'yahoo.it': ['eu'],
    'yandex.by': ['ru'],
    'yandex.com': ['ru'],
    'yandex.kz': ['ru'],
    'yandex.ru': ['us','sg','ru'],
    'yandex.ua': ['ru'],
    'ybb.ne.jp': ['sg'],
    'ymail.com': ['us','sg']
},

getVerifiedDomains = function(realm) {
    return _.filter(_.keys(domains), function(domain) {
        return domains[domain].indexOf(realm) !== -1;
    });

},

verifiedDomains = _.extract('Settings.Mailcheck.verifiedDomains',
                            getVerifiedDomains(_.extract('Settings.REALM')),
                            true);

export default verifiedDomains;



// WEBPACK FOOTER //
// ./~/wgnet-awesomejs/lib/clientvalidation/verifieddomains.js